import cn from 'classnames';
import type { ChangeEvent } from 'react';
import React from 'react';

import s from './Checkbox.module.scss';

interface CheckboxProps
  extends Omit<React.HTMLAttributes<HTMLInputElement>, 'onChange'> {
  id: string;
  name: string;
  labelText?: string | JSX.Element;
  checked?: boolean;
  isDisabled?: boolean;
  onChange: (checked: boolean) => void;
}

const Checkbox: React.FC<CheckboxProps> = props => {
  const {
    id,
    name,
    labelText: label,
    onChange: handleChange,
    className,
    isDisabled,
    children,
    ...restProps
  } = props;

  function onChange(e: ChangeEvent<HTMLInputElement>): void {
    handleChange(e.target.checked);
  }

  return (
    <label
      htmlFor={id}
      className={cn(s.label, className, { [s.disabled]: isDisabled })}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        onChange={onChange}
        className={s.checkbox}
        disabled={isDisabled}
        {...restProps}
      />
      <span className={s.labelText}>{children ? children : label}</span>
    </label>
  );
};

export default Checkbox;
